import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  initialize() {
    this.timeout = null
  }

  search(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      event.target.form.requestSubmit()
    }, 200)
  }

  connect() {
    this.formTargets.forEach((form) => {
      form.addEventListener("input", this.search.bind(this))
      form.addEventListener("change", this.search.bind(this))
    })
  }

  disconnect() {
    this.filterTargets.forEach((form) => {
      form.addEventListener("input", this.search.bind(this))
      form.removeEventListener("change", this.search.bind(this))
    })
  }
}

